import React, { useContext, useEffect, useState, useCallback } from 'react';
import Form from 'src/components/controls/forms/Form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import CardContainer from 'src/components/common/CardContainer.redesign';
import { AnyObject } from 'final-form';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Filter from 'src/components/common/Filter';
import { ODataOptions } from 'src/util/ODataBuilder';
import useFetch from 'use-http';
import GISHorizon from 'src/models/GISHorizon';
import moment from 'moment';
import { DocumentTypes } from 'src/models/DocumentTypes';
import { IAppContextState } from 'src/reducers/AppContext';
import { AppContext } from 'src/providers/AppContextProvider';
import * as _ from 'lodash';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PagedResultSet from 'src/models/common/PagedResultSet';
import DocumentManagement from '../layout/DocumentManagement';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import MathUtil from 'src/util/MathUtil';
import { ITableConfig } from 'src/components/common/table';
import * as Constants from 'src/components/common/Constants';
import GISNavbar from './GISNavbar';

type fileDataType = {
    id: number;
    originalFileName: string;
    fileSize: number;
    fileExtension: string;
    fileType: string;
    s3FileId: number;
    s3KeyName: string;
    uploadDate: Date;
    note: string;
    docType: string;
};

const GISData = () => {
    const appContext = useContext<IAppContextState>(AppContext);
    const [horizons, setHorizons] = useState<PagedResultSet<GISHorizon>>(undefined);
    const [selectedHorizon, setSelectedHoriozon] = useState<GISHorizon>(undefined);
    const [attachedFiles, setAttachedFiles] = useState(undefined);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [isOnLastPage, setIsOnLastPage] = useState<boolean>(false);
    const [filters, setFilters] = useState('');
    const dispatch = useDispatch();

    const { get, response, put } = useFetch();

    const initialGISConfig: ITableConfig = { rowCount: Constants.gisDataAccessSearchRowCount, pageNumber: 1 };

    useEffect(() => {
        let lastPage = false;
        if (horizons) {
            lastPage = horizons.pageNumber * horizons.pageSize < horizons.totalRecords;
        }
        setIsOnLastPage(lastPage);
    }, [horizons]);

    const getHorizons = async (filter: string, nextPage: boolean) => {
        setIsDataLoading(true);
        const result = await get(`/v1.0/gis/horizons${filter}`);
        if (response.ok) {
            if (nextPage === true) {
                let tempResult = _.cloneDeep(horizons);
                tempResult.pageNumber += 1;
                tempResult.items = [...tempResult.items].concat([...result.items]);
                setHorizons(tempResult);
            } else {
                setHorizons(result);
            }
        } else {
            console.log('bad request', response, filters);
        }
        setIsDataLoading(false);
    };

    const searchUpdate = useCallback(
        _.debounce((filter: string) => {
            getHorizons(filter, false);
            console.log('getting those horizons', filter);
        }, Constants.gisDataAccessSearchDebounceDelay),
        []
    );

    const updateFilter = (options: ODataOptions) => {
        let configOptions = ODataOptions.from(initialGISConfig);
        configOptions.merge(options);

        const stringOptions = configOptions.toString();
        setFilters(stringOptions);
        searchUpdate(stringOptions);
        console.log('New Filter Options', stringOptions);
    };

    // useEffect(() => {
    //     searchUpdate();
    // }, [filters]);

    const onSubmit = (values: AnyObject) => {
        console.log('invoice values', values);
    };

    const selectHorizon = (gisHorizon: GISHorizon) => {
        if (gisHorizon.id === selectedHorizon?.id) {
            setSelectedHoriozon(undefined);
        } else {
            setSelectedHoriozon(gisHorizon);
            getAttachedFiles(gisHorizon);
        }
    };

    const getAttachedFiles = async (gisHorizon: GISHorizon) => {
        console.log('at get');
        const data = await get(
            `/v1.0/clients/${gisHorizon?.clientNumber}/projects/${gisHorizon?.projectNumber}/fields/${gisHorizon?.sectionNumber}/tracts/${gisHorizon?.tractNumber}/horizons/${gisHorizon?.horizonNumber}/s3bucket`
        );
        if (response.ok) {
            console.log('dataaaa', data);
            setAttachedFiles(data);
        }
    };

    const getCSV = async () => {
        if (selectedHorizon) {
            const result = await get(`/v1.0/gis/csv/client/${selectedHorizon?.clientNumber}/project/${selectedHorizon?.projectNumber}`);
            if (response.ok) {
                if (result.length > 0) {
                    let csvResult = new Array<string[]>();
                    csvResult.push(Object.keys(result[0]));

                    result.forEach((item: unknown) => {
                        let row = Object.values(item);
                        csvResult.push(row.map((value: string) => {
                            return '"' + value + '"';
                        }));
                    });

                    let csvContent = 'data:text/csv;charset=utf-8,'
                        + csvResult.map(e => e.join(',')).join('\n');
                    var encodedUri = encodeURI(csvContent);
                    let regex: RegExp = /#/gi;
                    encodedUri = encodedUri.replace(regex, '%23');
                    window.open(encodedUri);
                }
            }
        } else {
            window.alert('Please Select A Horizon Before Generating CSV');
        }
    };

    const horizonCardStyle = (id: number) => {
        if (id === selectedHorizon?.id) {
            return { display: 'flex', marginBottom: '.5rem', backgroundColor: 'lightblue', borderBottom: '1px solid grey', padding: '.5rem' };
        } else {
            return { display: 'flex', marginBottom: '.5rem', backgroundColor: 'white', borderBottom: '1px solid grey', padding: '.5rem' };
        }
    };

    const gisHorizonCard = (gisHorizon: GISHorizon) => {
        return (
            <div onClick={() => selectHorizon(gisHorizon)} className="clickable" style={horizonCardStyle(gisHorizon.id)}>
                <div style={{ width: '10%', marginRight: '1rem' }}>{gisHorizon?.projectName}</div>
                <div style={{ width: '10%', marginRight: '1rem' }}>
                    {`${gisHorizon.clientNumber}.${gisHorizon.projectNumber}.${gisHorizon.sectionNumber}.${gisHorizon.tractNumber}-${gisHorizon.horizonNumber}`}
                </div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{MathUtil.cleanNumber(gisHorizon?.grossAcres, 7)}</div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{gisHorizon?.parcelId || 'N/A'}</div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{gisHorizon?.isPlotted === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{gisHorizon?.ownershipType || 'N/A'}</div>
                <div style={{ width: '5%', marginRight: '1rem' }}>NA</div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{gisHorizon?.isApproved === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{gisHorizon?.hasPlat === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '6%', marginRight: '1rem' }}>{gisHorizon?.hasSourceDeed === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '5%', marginRight: '1rem' }}>{gisHorizon?.isLeased === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '5%', marginRight: '1rem' }}>{gisHorizon?.isHBP === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '5%', marginRight: '1rem' }}>{gisHorizon?.isTargetHorizon === true ? 'Yes' : 'No'}</div>
                <div style={{ width: '20%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{gisHorizon?.legalDescription}</div>
            </div>
        );
    };

    const tractList = () => {
        if (horizons?.items.length > 0) {
            return horizons?.items?.map((gisHorizon: GISHorizon, index: number) => {
                return <div key={index}>{gisHorizonCard(gisHorizon)}</div>;
            });
        } else if (isDataLoading) {
            return <div>Loading...</div>;
        } else {
            return <div>No Tracts Found</div>;
        }
    };

    const displayFiles = () => {
        if (attachedFiles?.length > 0) {
            return attachedFiles.map((file: fileDataType, index: number) => {
                return (
                    <div
                        key={index}
                        style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid darkgrey' }}
                        className="mb-2"
                    >
                        <div style={{ width: '10%', textAlign: 'center' }}>{moment(file.uploadDate).format('MM-DD-YYYY')}</div>
                        <div style={{ width: '30%', textAlign: 'center' }}>{file.originalFileName}</div>
                        <div style={{ width: '10%', textAlign: 'center' }}>{calcFileSize(file.fileSize)}</div>
                        <div style={{ width: '10%', textAlign: 'center' }}>{docType(file.docType).name}</div>
                        <div style={{ width: '25%', textAlign: 'center' }}>{file.note}</div>
                        <div style={{ width: '15%', textAlign: 'center' }}>
                            <a onClick={() => downloadFile(file.s3KeyName, index, file.originalFileName)}>
                                <i style={{ fontSize: '1.7rem' }} className="far fa-download mr-1 clickable" />
                            </a>

                            {/* <i style={{ fontSize: '1.7rem' }} className="far fa-eye mr-1 clickable" onClick={() => props.showDialog(DialogList.DOCUMENT_VIEWER)} /> */}

                            <i style={{ fontSize: '1.7rem' }} className="far fa-info-circle clickable" />
                        </div>
                        <a id={`a_${index}`} />
                    </div>
                );
            });
        } else {
            return <div>No Files Found</div>;
        }
    };

    const onFileUploaded = () => {
        dispatch(actions.layout.hideDialog());
        if (selectedHorizon) {
            getAttachedFiles(selectedHorizon);
        }
    };

    const calcFileSize = (fileSize: number) => {
        console.log('isNan', isNaN(fileSize));
        if (!isNaN(fileSize)) {
            const size = fileSize / 1000 + 'Kb';

            return size;
        }
        return 'NA';
    };

    const docType = (docTypeValue: string) => {
        const numDocType = parseInt(docTypeValue, 10);
        if (numDocType) {
            const type = DocumentTypes.find((dc) => dc.id === numDocType) || { name: 'Bad Doc Type' };
            return type;
        }
        return { name: 'No Doc Type Set' };
    };

    const downloadFile = async (keyName: string, index: number, fileName: string) => {
        await get(`/v1.0/s3bucket/${keyName}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.getElementById(`a_${index}`) as HTMLAnchorElement;
                a.href = blobUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        }
    };

    // const plottingIssues = () => {
    //     return <div>No Plotting Issues</div>;
    // };

    const setHorizonAsPlotted = async (plottingMethod: number) => {
        if (selectedHorizon) {
            const horizonId = selectedHorizon.id;

            const result = await put(`/v1.0/gis/horizon/${horizonId}/plottingMethod/${plottingMethod}`);

            if (response.ok) {
                // do stuff
                console.log(result);
                searchUpdate(filters);
            }
        } else {
            window.alert('Please Select Horizon Before Attempting to Mark as Plotted');
        }
    };

    const navTractDetail = () => {
        if (selectedHorizon) {
            dispatch(
                push(
                    `/clients/${selectedHorizon.clientNumber}/projects/${selectedHorizon.projectNumber}/sections/${selectedHorizon.sectionNumber
                    }/tracts/${selectedHorizon.tractNumber}/horizons/${selectedHorizon.horizonNumber || 1}`
                )
            );
        } else {
            window.alert('Please Select Horizon Before Attempting to Navigate to Tract Detail');
        }
    };

    const incrementPage = () => {
        let newConfig = initialGISConfig;
        newConfig.pageNumber = horizons.pageNumber + 1;

        const options = ODataOptions.from(newConfig);

        getHorizons(options.toString(), true);
    };

    return (
        <div style={{ overflowY: 'hidden' }}>
            <GISNavbar />
            <Page>
                <Page.Section width={12}>
                    <Panel>
                        <div style={{ margin: '2rem' }}>
                            <h2 style={{ textAlign: 'center' }}>GIS Data Access</h2>

                            <Form onSubmit={onSubmit}>
                                <>
                                    <div>
                                        <div style={{ display: 'flex', fontSize: '2rem', marginBottom: '1rem' }}>
                                            <div style={{ marginRight: '1rem' }}>Cartographer:</div>
                                            <div>{appContext?.currentUser?.username || 'Problem Gathering User Data'}</div>
                                        </div>
                                    </div>

                                    <div>
                                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                            <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Tract List</legend>
                                        </fieldset>

                                        <div style={{ marginLeft: '-1rem', marginRight: '-1rem' }}>
                                            <Filter
                                                // items={[
                                                //     { group: 1, text: 'invisible', icon: 'numeric-up', orderName: 'invisible', orderDirection: 'ascending' },
                                                //     { group: 1, text: 'Global Number', icon: 'numeric-up', orderName: 'globalId', orderDirection: 'ascending' },
                                                //     { group: 1, text: 'Global Number Desc', icon: 'numeric-down', orderName: 'globalId', orderDirection: 'descending' },
                                                // ]}
                                                sortItems={[
                                                    { group: 1, text: 'invisible', icon: 'numeric-up', orderName: 'invisible', orderDirection: 'ascending' },
                                                ]}
                                                filterItems={[
                                                    { group: 1, text: 'invisible', orderName: 'invisible', orderDirection: 'ascending', type: 'topic' },
                                                    { group: 1, text: 'Plotted', orderName: 'plotted', orderDirection: 'ascending', type: 'topic' },
                                                    { group: 1, text: 'Unplotted', orderName: 'unplotted', orderDirection: 'ascending', type: 'topic' },
                                                    // { group: 1, text: 'New Tracts', orderName: 'newTracts', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Modified Tracts', orderName: 'modifiedTracts', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Date Range', orderName: 'dateRange', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Approved', orderName: 'approved', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Unapproved', orderName: 'unapproved', orderDirection: 'ascending' },
                                                    { group: 1, text: 'Has Plat', orderName: 'hasPlat', orderDirection: 'ascending', type: 'topic' },
                                                    { group: 1, text: 'No Plat', orderName: 'noPlat', orderDirection: 'ascending', type: 'topic' },
                                                    // { group: 1, text: 'Has Source Deed', orderName: 'hasSourceDeed', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'No Source Deed', orderName: 'noSourceDeed', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Leased', orderName: 'leased', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Unleased', orderName: 'unLeased', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'HBP', orderName: 'hbp', orderDirection: 'ascending' },
                                                    // { group: 1, text: 'Non-HBP', orderName: 'nonHBP', orderDirection: 'ascending' },
                                                    { group: 1, text: 'Target Horizon', orderName: 'targetHorizon', orderDirection: 'ascending', type: 'topic' },
                                                    { group: 1, text: 'Non Target Horizon', orderName: 'nonTargetHorizon', orderDirection: 'ascending', type: 'topic' },
                                                ]}
                                                onFilterChanged={updateFilter}
                                            />
                                            <div style={{ minHeight: '10rem', maxHeight: '30rem', overflow: 'auto' }} id="what">
                                                <CardContainer
                                                    showNextPagePanel={isOnLastPage}
                                                    nextPageAction={incrementPage}
                                                >
                                                    {tractList()}
                                                </CardContainer>
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', marginBottom: '.5rem' }}>
                                            <div style={{ width: '10%', textDecoration: 'underline', marginRight: '1rem' }}>Project</div>
                                            <div style={{ width: '10%', textDecoration: 'underline', marginRight: '1rem' }}>Global ID</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Gross Acres</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Parcel ID</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Plotted</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Own. Type</div>
                                            <div style={{ width: '5%', textDecoration: 'underline', marginRight: '1rem' }}>Action</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Apr</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Plat</div>
                                            <div style={{ width: '6%', textDecoration: 'underline', marginRight: '1rem' }}>Src</div>
                                            <div style={{ width: '5%', textDecoration: 'underline', marginRight: '1rem' }}>Lsd</div>
                                            <div style={{ width: '5%', textDecoration: 'underline', marginRight: '1rem' }}>HPB</div>
                                            <div style={{ width: '5%', textDecoration: 'underline', marginRight: '1rem' }}>TGT</div>
                                            <div style={{ width: '20%', textDecoration: 'underline', marginRight: '1rem' }}>Legal Description</div>
                                        </div>
                                    </div>

                                    <div style={{ display: 'flex', marginBottom: '1.5rem' }}>
                                        <div style={{ width: '100%', paddingRight: '1rem' }}>
                                            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                                <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Attached Documents</legend>
                                            </fieldset>
                                            <div style={{ marginLeft: '1rem' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                    <div style={{ textDecoration: 'underline' }}>Doc Date</div>
                                                    <div style={{ textDecoration: 'underline' }}>Doc Kind</div>
                                                    <div style={{ textDecoration: 'underline' }}>Doc Note</div>
                                                    <div style={{ textDecoration: 'underline' }}>File</div>
                                                </div>
                                                <div style={{ minHeight: '10rem' }}>{displayFiles()}</div>
                                            </div>

                                            <div style={{ width: '50%' }}>
                                                <div>
                                                    <div style={{ marginBottom: '1rem' }}>
                                                        <Button
                                                            text="Upload Plat"
                                                            onClick={() => selectedHorizon ? dispatch(actions.layout.showDialog(DialogList.DOCUMENT_MANAGEMENT)) : window.alert('Please Select Horizon Before Attaching Plat')}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div style={{ width: '49%', paddingRight: '1rem' }}>
                                        <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                            <legend style={{ marginLeft: '2rem', padding: '0 .5rem' }}>Plotting Issues</legend>
                                        </fieldset>
                                        <div style={{ marginLeft: '1rem' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <div style={{ textDecoration: 'underline' }}>Note Date</div>
                                                <div style={{ textDecoration: 'underline' }}>Note By</div>
                                                <div style={{ textDecoration: 'underline' }}>Note</div>
                                            </div>
                                            <div style={{ minHeight: '10rem' }}>{plottingIssues()}</div>
                                            <div style={{ marginBottom: '1rem' }}>
                                                <Button text="Create Plotting Issue" />
                                            </div>
                                        </div>
                                    </div> */}
                                    </div>
                                    {/* <div style={{ display: 'flex', marginBottom: '1rem' }}>
                                    <div style={{ marginRight: '1rem' }}>
                                        <Button type="submit" text="Mark Plotted Using Legal Description" onClick={() => setHorizonAsPlotted(1)} />
                                    </div>
                                    <Button text="Mark Plotted Using Source Deed" onClick={() => setHorizonAsPlotted(2)} />
                                </div> */}
                                    <div style={{ display: 'flex' }}>
                                        <div>
                                            <Button text="Mark Plotted Using Plat" onClick={() => setHorizonAsPlotted(3)} />
                                        </div>

                                        <div style={{ marginLeft: '1rem' }}>
                                            <Button text="Tract Detail" onClick={navTractDetail} />
                                        </div>

                                        <div style={{ marginLeft: '1rem' }}>
                                            <Button text="Create CSV File" onClick={getCSV} />
                                        </div>

                                        {/* <Button text="Mark With Issue" onClick={() => setHorizonAsPlotted(4)} /> */}
                                    </div>
                                </>
                            </Form>
                        </div>
                        {selectedHorizon &&
                            <DocumentManagement
                                filesUploaded={onFileUploaded}
                                context="gis"
                                clientNumber={selectedHorizon?.clientNumber}
                                projectNumber={selectedHorizon?.projectNumber}
                                fieldNumber={selectedHorizon?.sectionNumber}
                                tractNumber={selectedHorizon?.tractNumber}
                                horizonNumber={selectedHorizon?.horizonNumber}
                            />
                        }
                    </Panel>
                </Page.Section>
            </Page>
        </div>
    );
};

export default GISData;



// WEBPACK FOOTER //
// ./src/components/gis/GISData.tsx